import React, { useState } from "react";
import { Link } from "react-router-dom";
import { authService } from "../../services/authService";
import styles from "./forgotPassword.module.scss";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle | loading | success | error
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");
    setMessage("");
    try {
      const res = await authService.forgotPassword(email);
      setStatus("success");
      setMessage(
        res?.message ||
          "Si un compte existe pour cet email, un lien de réinitialisation a été envoyé."
      );
    } catch (err) {
      setStatus("error");
      setMessage(err.message || "Erreur lors de la demande de réinitialisation");
    }
  };

  return (
    <div className={styles.container}>
      <h1>nouveau mot de passe</h1>
      <p>
        Saisis ton email. Si un compte existe, tu recevras un lien de
        réinitialisation.
      </p>

      {message && (
        <div className={status === "error" ? styles.error : styles.success}>
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit} className={styles.form}>
        <label htmlFor="email">Email</label>
        <input
          id="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button type="submit" disabled={status === "loading"}>
          {status === "loading" ? "Envoi..." : "Envoyer le lien"}
        </button>
      </form>

      <div className={styles.back}>
        <Link to="/connect">Retour à la connexion</Link>
      </div>
    </div>
  );
};

export default ForgotPassword;

